import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "PTR",
  title: defineMessage({
    id: "fig.quality.PTR.title",
    defaultMessage: `The number of pupils per teacher is reducing in most countries over time`,
  }),
  caption: defineMessage({
    id: "fig.quality.PTR.caption",
    defaultMessage: `The number of pupils per teacher has generally been declining outside of phases of rapid school expansion.`,
  }),
  source: defineMessage({ id: "fig.quality.PTR.source", defaultMessage: `UIS database` }),
};
